import { ContractStatusEnum } from '@/enums/contract-status.enum';
import { RequestStatusEnum } from '@/enums/request-status.enum';

export abstract class Utils {
  /**
   * Allows only digits, backspace and ctrl+v keys.
   * @param event The keyboard event object.
   */
  public static AllowDigitsKeys(event: KeyboardEvent): void {
    if (['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'Backspace'].indexOf(event.key) === -1
      && (event.key !== 'v' || !event.ctrlKey)) {
      event.preventDefault();
    }
  }

  /**
   * Gets the request status CSS class.
   * @param status The request status identifier.
   * @returns The request status CSS class.
   */
  public static getRequestStatusCssClass(status: RequestStatusEnum | null): string | never {
    if (!status) return '';

    switch (status) {
      case RequestStatusEnum.Pending:
        return 'contract-status-pending';
      case RequestStatusEnum.Approved:
        return 'contract-status-valid';
      case RequestStatusEnum.Cancelled:
        return 'contract-status-cancelled';
      case RequestStatusEnum.Rejected:
        return 'contract-status-rejected';
      default:
        throw new Error('Invalid request status value.');
    }
  }

  /**
   * Gets the contract status CSS class.
   * @param status The contract status identifier.
   * @returns The contract status CSS class.
   */
  public static getContractStatusCssClass(status: ContractStatusEnum | null): string | never {
    if (!status) return '';

    switch (status) {
      case ContractStatusEnum.Pending:
        return 'contract-status-pending';
      case ContractStatusEnum.Cancelled:
        return 'contract-status-cancelled';
      case ContractStatusEnum.Valid:
        return 'contract-status-valid';
      case ContractStatusEnum.Expired:
        return 'contract-status-expired';
      case ContractStatusEnum.Rejected:
        return 'contract-status-rejected';
      case ContractStatusEnum.Closed:
        return 'contract-status-closed';
      default:
        throw new Error('Invalid contract status value.');
    }
  }
}
